import { IBaseEntityDTO, BaseEntityDTO } from './base.entity.dto';

export interface ICastCrewDTO extends IBaseEntityDTO {
  name: string;
  description: string;
}

export class CastCrewDTO extends BaseEntityDTO implements ICastCrewDTO {
  name: string;
  description: string;

  constructor(data?: Partial<ICastCrewDTO>) {
    super(data);
    this.name = data?.name || '';
    this.description = data?.description || '';
  }
}
